import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Button, Radio } from "antd";
import Language from "../language/language";
import "./stylesheets/selectBBSTeam.scss";

@inject("languageStore", "authStore", "teamStore", "gameStore")
@withRouter
@observer
class SelectBBSTeam extends React.Component {
  state = { value: undefined, confirmDisabled: true };

  onChange = e => {
    this.setState({
      value: e.target.value,
      confirmDisabled: false
    });
  };

  handleClose = () => {
    this.props.teamStore.setSelectBBSTeamModalState(false);
  };
  handleConfirm = () => {
    this.props.teamStore.setCurrentSelectBBSTeamId(this.state.value);
    this.handleClose();
    this.props.history.push("/create-team");
  };

  render() {
    const bbsTeamWithManagement = this.props.authStore.bbsTeamWithManagement;
    const selectedGame = this.props.gameStore.selectedGame;

    const { confirmDisabled, value } = this.state;

    return (
      <div className="selectBBSTeam">
        {selectedGame && selectedGame.attributes && selectedGame.attributes.title && (
          <Language
            className="selectBBSTeam__eventName"
            resource="SELECT_TEAM_TIPS"
            keys={[selectedGame.attributes.title]}
          />
        )}
        <Radio.Group onChange={this.onChange} value={value}>
          {bbsTeamWithManagement.map((item, index) => {
            const { colleges, nameZh, nameEn, id, teamType } = item;
            const schoolesName = colleges.map(item => item.collegeName).join(" ");

            return (
              <Radio key={`${id}-${index + 1}`} value={id}>
                <div className="selectBBSTeam__radio">
                  <div className="selectBBSTeam__radio--schools">{schoolesName}</div>
                  <div className="selectBBSTeam__radio--teamName">{`${nameZh || nameEn}${
                    teamType === 1 ? "战队" : "联队"
                  }`}</div>
                </div>
              </Radio>
            );
          })}
        </Radio.Group>
        <div className="selectBBSTeam__btns">
          <Button onClick={this.handleClose}>{"取消"}</Button>
          <Button onClick={this.handleConfirm} type="primary" disabled={confirmDisabled}>
            {"确认"}
          </Button>
        </div>
      </div>
    );
  }
}

export default SelectBBSTeam;



// WEBPACK FOOTER //
// ./src/components/registrationCenter/selectBBSTeam.js